import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Danhmuctuyencodinh from "components/Danhmuc/Tuyencodinh/Danhmuctuyencodinh.js";
export default function Dmtuyenxe() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Tuyến xe cố định",
            tabContent: <Danhmuctuyencodinh />,
          },
        ]}
      />
    </div>
  );
}
